import React, { Component } from 'react';
import { Button, FormControl, Modal, FormGroup, ControlLabel } from 'react-bootstrap'
import WorkdocStore from '../../stores/WorkdocStore'
import FontAwesome from 'react-fontawesome'
import ConfirmPopup from 'component/element/ConfirmPopup'
import {connect} from 'react-redux'
var NotificationSystem = require('react-notification-system');

class WorkDocCategoryModal extends Component {

  constructor(props) {
    super(props)

    this.state = {
      categorys:[],
      showAddCate:false,
      actionCate:'add',
      cate_name:'',
      cate_id:'',
      showDel:false
    }
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
  }

  componentWillReceiveProps(newProps) {
    if (newProps.show&&newProps.show!==this.props.show) {
      this.setState({categorys:newProps.categorys}) 
    }
  }

  onRowCategoryEdit(item,index) {
    this.setState({cate_id:item.value,cate_name:item.label,actionCate:'edit',showAddCate:true})
  }

  onCategoryNameChange(e) {
    this.setState({cate_name:e.target.value})
  }

  onCategorySaveClick() {
    let {cate_name,cate_id,actionCate,categorys} = this.state
    if (cate_name==='')
      return false
    
    let postData = {}
    if (actionCate==='add') {
      postData = {name:cate_name} 
    } else {
      postData = {name:cate_name,id:cate_id}
    }
    WorkdocStore.saveWageCategory(postData,(result)=>{
      if (result.status==='OK') {
        if (actionCate==='add')
          categorys.push({label:result.data.name,value:result.data.id})
        else {
          let key = categorys.findIndex(x=>x.value===result.data.id)
          if (key!==-1)
            categorys[key].label = result.data.name
        }

        this._notificationSystem.addNotification({
          title:'แจ้งเตือน',
          message:'ทำการบันทึกรายการหมวดหมู่สำเร็จ',
          level:'info',
          category:'tc'
        });
        this.setState({cate_name:'',cate_id:'',showAddCate:false,actionCate:'add',categorys:categorys})
        this.props.onUpdateCategory(categorys)
      }
    },()=>{
      this.setState({cate_name:'',cate_id:'',showAddCate:false,actionCate:'add'})
      this._notificationSystem.addNotification({
        title:'แจ้งเตือน',
        message:'ไม่สามารถบันทึกรายการหมวดหมู่ได้',
        level:'error',
        category:'tc'
      });
    })
  }

  onConfirmDel() {
    let {cate_id,categorys} = this.state
    WorkdocStore.delWageCategory(cate_id,(result)=>{
      if (result.status==='OK') {
        let key = categorys.findIndex(x=>x.value===cate_id)
        if (cate_id!==-1)
          categorys.splice(key,1)
        
        this._notificationSystem.addNotification({
          title:'แจ้งเตือน',
          message:'ทำการลบรายการหมวดหมู่สำเร็จ',
          level:'info',
          category:'tc'
        });
        this.setState({cate_name:'',cate_id:'',showDel:false,actionCate:'add',showAddCate:false,categorys:categorys})
        this.props.onUpdateCategory(categorys)
      }
    },()=>{
      this._notificationSystem.addNotification({
        title:'แจ้งเตือน',
        message:'ไม่สามารถลบรายการหมวดหมู่ได้',
        level:'error',
        category:'tc'
      });
      this.setState({cate_name:'',cate_id:'',showDel:false,actionCate:'add',showAddCate:false})
    })
  }

  renderCategoryRowData() {
    let {categorys} = this.state
    if (categorys.length===0) {
      return(<tr><td colSpan={3}>ไม่พบข้อมูล</td></tr>)
    } else {
      return(
        categorys.map((item,index)=>(
          <tr key={index}>
            <td className='text-center'>{index+1}</td>
            <td className='text-left'>{item.label}</td>
            <td className='text-center'><Button style={{display:(index>0?'':'none')}} onClick={this.onRowCategoryEdit.bind(this,item,index)}>แก้ไข</Button></td>
          </tr>
        ))
      )
    }
  }

  render() {
    let {cate_name,cate_id,actionCate,showAddCate,showDel} = this.state
    let {show} = this.props
    return(
  		<div>
        <Modal bsSize="large" show={show} onHide={this.props.onHide}>
          <Modal.Header closeButton>
            <Modal.Title>หมวดหมู่</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {!showAddCate?
            <div>
              <div className='text-right'><Button bsStyle='link' onClick={()=>{this.setState({showAddCate:true})}}><FontAwesome name='plus' /> เพิ่มหมวดหมู่</Button></div>
              <div className='table-responsive'>
                <table className='table table-hover table-bordered-solid'>
                  <thead>
                    <tr>
                      <th className='text-center' style={{width:'50px'}}>ลำดับ</th>
                      <th className='text-center' style={{width:'150px'}}>หมวดหมู่</th>
                      <th className='text-center' style={{width:'50px'}}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.renderCategoryRowData()}
                  </tbody>
                </table>
              </div>
            </div>  
            :
            <form>
              <FormGroup>
                <ControlLabel>ชื่อหมวดหมู่</ControlLabel>
                <FormControl
                  value={cate_name}
                  onChange={this.onCategoryNameChange.bind(this)}
                />
              </FormGroup>
            </form>
            }
          </Modal.Body>
          {showAddCate?
          <Modal.Footer>
            {cate_id!==''&&actionCate==='edit'?
            <Button bsStyle='danger' onClick={()=>{this.setState({showDel:true})}}><FontAwesome name='trash' />&nbsp;ลบหมวดหมู่</Button>
            :''}
            <Button bsStyle={'primary'} onClick={this.onCategorySaveClick.bind(this)}><FontAwesome name='save' />&nbsp;บันทึก</Button>
            <Button onClick={()=>{this.setState({showAddCate:false,cate_name:'',cate_id:'',actionCate:'add'})}}><FontAwesome name='close' />&nbsp;กลับ</Button>
          </Modal.Footer>
          :''}
        </Modal>
        <ConfirmPopup
          show={showDel}
          onHide={()=>{this.setState({showDel:false})}}
          title='ยืนยันทำรายการลบหรือไม่ ?'
          message='รายการค่าแรงที่อยู่ในหมวดนี้ จะถูกย้ายไปในหมวหมู่ "ไม่ระบุค่าแรง"'
          onConfirm={this.onConfirmDel.bind(this)}
        />
        <NotificationSystem ref="notificationSystem" />
      </div>
  	)
  }
}
 
export default WorkDocCategoryModal = connect(
  (state) => ({messages: state.message.view.workdoc.WorkDocCategoryModal}),null,null,{withRef:true}
)(WorkDocCategoryModal);



// WEBPACK FOOTER //
// ./src/view/workdoc/WorkDocCategoryModal.js